/**
 * @author xxx
 * 模块说明：渠道库存管理
 */

import { Service } from '@/tools'
export class ChannelStockService <T extends TStock.ChannelStock> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.ChannelStock}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
  
            
  /**
   * 功能：业务库存异动
   */
  stockChange = (data: T['ApiStockChange']['req']): Promise<T['ApiStockChange']['res']> => this.post2('v1/ApiStockChange', data)
            
  /**
   * 功能：渠道库存分页查询
   */
  pageList = (data: T['ApiPageList']['req']): Promise<T['ApiPageList']['res']> => this.post2('v1/ApiPageList', data)
            
  /**
   * 功能：查询渠道仓库存详情
   */
  detail = (data: T['ApiDetail']['req']): Promise<T['ApiDetail']['res']> => this.post2('v1/ApiDetail', data)
}
